var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "proofreading-preview-plan" }, [
    _c("h1", { staticClass: "proofreading-preview-plan__heading" }, [
      _vm._v(" " + _vm._s(_vm.$t("proofreadingPreviewPlanPage.heading")) + " "),
    ]),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "proofreading-preview-plan__loading" },
          [
            _c("LoadingSpinner", {
              attrs: {
                size: "small",
                variant: "inline",
                text: _vm.$t("proofreadingPreviewPlanPage.loading"),
              },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "proofreading-preview-plan__content" }, [
          _c("section", { staticClass: "preview-section" }, [
            _c("h2", { staticClass: "preview-section__title" }, [
              _vm._v(
                _vm._s(_vm.$t("proofreadingPreviewPlanPage.novelSectionTitle"))
              ),
            ]),
            _c(
              "dl",
              { staticClass: "preview-field-list" },
              _vm._l(_vm.novelInfoFields, function (field) {
                return _c(
                  "div",
                  { key: field.name, staticClass: "preview-field" },
                  [
                    _c(
                      "dt",
                      {
                        staticClass: "preview-field__label",
                        class: { "preview-field__label--empty": !field.filled },
                      },
                      [_vm._v(" " + _vm._s(field.label) + " ")]
                    ),
                    _c(
                      "dd",
                      {
                        staticClass: "preview-field__value",
                        class: { "preview-field__value--empty": !field.filled },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            field.value ||
                              _vm.$t("proofreadingPreviewPlanPage.emptyValue")
                          )
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _c("section", { staticClass: "preview-section" }, [
            _c("h2", { staticClass: "preview-section__title" }, [
              _vm._v(
                _vm._s(_vm.$t("proofreadingPreviewPlanPage.themeSectionTitle"))
              ),
            ]),
            _c(
              "dl",
              { staticClass: "preview-field-list" },
              _vm._l(_vm.themePreviewBlocks, function (block) {
                return _c(
                  "div",
                  {
                    key: block.kind === "field" ? block.field.name : "target",
                    staticClass: "preview-field",
                  },
                  [
                    block.kind === "field"
                      ? [
                          _c(
                            "dt",
                            {
                              staticClass: "preview-field__label",
                              class: {
                                "preview-field__label--empty": !block.field
                                  .filled,
                              },
                            },
                            [_vm._v(" " + _vm._s(block.field.label) + " ")]
                          ),
                          _c(
                            "dd",
                            {
                              staticClass: "preview-field__value",
                              class: {
                                "preview-field__value--empty": !block.field
                                  .filled,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  block.field.value ||
                                    _vm.$t(
                                      "proofreadingPreviewPlanPage.emptyValue"
                                    )
                                )
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c("dt", { staticClass: "preview-field__label" }, [
                            _vm._v(_vm._s(block.title)),
                          ]),
                          _c(
                            "dd",
                            { staticClass: "preview-field__target" },
                            _vm._l(block.fields, function (field) {
                              return _c(
                                "div",
                                {
                                  key: field.name,
                                  staticClass: "preview-field__nested",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "preview-field__sub-label",
                                      class: {
                                        "preview-field__sub-label--empty": !field.filled,
                                      },
                                    },
                                    [_vm._v(_vm._s(field.label))]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "preview-field__value",
                                      class: {
                                        "preview-field__value--empty": !field.filled,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          field.value ||
                                            _vm.$t(
                                              "proofreadingPreviewPlanPage.emptyValue"
                                            )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]),
    _c("div", { staticClass: "proofreading-preview-plan__footer" }, [
      _c(
        "button",
        {
          staticClass: "proofreading-preview-plan__back-button",
          attrs: {
            type: "button",
            disabled: _vm.isLoading || _vm.isConfirmingIncomplete,
          },
          on: { click: _vm.onClickBack },
        },
        [_vm._v(" " + _vm._s(_vm.$t("proofreadingPreviewPlanPage.back")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "proofreading-preview-plan__next-button",
          attrs: {
            type: "button",
            disabled: _vm.isLoading || _vm.isConfirmingIncomplete,
          },
          on: { click: _vm.onClickNext },
        },
        [_vm._v(" " + _vm._s(_vm.$t("proofreadingPreviewPlanPage.next")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }